import util from '../util'

let controller = 'BaixaOperacional'
export default Object.assign({}, util.GetCrud(controller, ['get', 'getall']), {
  BaixaEfetiva: function (dto) {
    return util.Axios.Post(controller + '/BaixaEfetiva', dto)
  },
  Devolver: function (dto) {
    return util.Axios.Post(controller + '/Devolver', dto)
  },
  AlterarContaPagamento: function(dto){
    return util.Axios.Post(controller + '/AlterarContaPagamento', dto)
  }
})
